
export const gamesConfig = [
    { path: "/casino/teen62", title: "V-VIP TEENPATTI 1-DAY" },
    { path: "/casino/dolidana", title: "DOLI DANA" },
    { path: "/casino/mogambo", title: "MOGAMBO" },

    { path: "/casino/lucky5", title: "LUCKY 5" },
    { path: "/casino/roulette13", title: "ROULETTE 13" },
    { path: "/casino/ourroullete", title: "OUR ROULETTE" },


    { path: "/casino/poison", title: "Teenpatti Poison One day" },
    //  { path: "/casino/ourroullete", title: "OUR ROULETTE" },
    { path: "/casino/poison20", title: "TEEnpatti poison 20 20" },
    { path: "/casino/teenunique", title: "Unique Teenpatti" },


    { path: "/casino/joker120", title: "Unlimited Joker 20-20" },
    { path: "/casino/joker20", title: "Teenpatti Joker 20-20" },
    { path: "/casino/joker1", title: "Unlimited Joker One Day" },
    { path: "/casino/teen20c", title: "20-20 TEENPATTI c" },
    { path: "/casino/teenjoker", title: "Teenpatti Joker" },

    { path: "/casino/btable2", title: "Bollywood Casino 2" },
    { path: "/casino/superover3", title: "Mini Super Over" },
    { path: "/casino/goal", title: "GOAL" },
    { path: "/casino/ab4", title: "ANDAR BAHAR 150 Cards" },
    { path: "/casino/lucky15", title: "LUCKY 15" },
    { path: "/casino/superover2", title: "SUPER OVER 2" },
    { path: "/casino/teen41", title: "QUEEN TOP OPEN TEENPATTI" },
    { path: "/casino/teen42", title: "JACK TOP OPEN TEENPATTI" },
    { path: "/casino/sicbo2", title: "SICBO 2" },
    { path: "/casino/teen33", title: "3 PATTI" },
    { path: "/casino/sicbo", title: "SICBO" },
    { path: "/casino/ballbyball", title: "BALL BY BALL" },
    { path: "/casino/teen32", title: "INSTANT TEENPATTI 2.0" },
    { path: "/casino/teen", title: "TEENPATTI 1 DAY" },
    { path: "/casino/teen20", title: "20-20 TEENPATTI" },
    { path: "/casino/teen9", title: "TEENPATTI TEST" },
    { path: "/casino/teen8", title: "TEENPATTI OPEN" },
    { path: "/casino/poker ", title: "POKER 1 DAY" },
    { path: "/casino/poker20", title: "20-20 POKER" },
    { path: "/casino/poker6", title: "POKER 6 PLAYER" },
    { path: "/casino/baccarat", title: "BACCARAT" },
    // BACCARAT ki ui set krni hai ki 
    { path: "/casino/baccarat2", title: "BACCARAT 2" },
    // BACCARAT 2 ki ui set krni hai ki 
    { path: "/casino/dt20", title: "20-20 DRAGON TIGER" },
    { path: "/casino/dt6", title: "1 DAY DRAGON TIGER" },
    { path: "/casino/dtl20", title: "20 20 DTL" },
    { path: "/casino/dt202", title: "20 20 Dragon Tiger 2" },
    { path: "/casino/card32", title: "32 CARDS A" },
    { path: "/casino/card32eu", title: "32 CARDS B" },
    // { path: "/casino/dtl20", title: "20 20 DTL" },
    { path: "/casino/dt202", title: "DRAGON TIGER 2" },
    { path: "/casino/card32", title: "32 CARDS" },
    { path: "/casino/card32eu", title: "32 CARDS B" },
    { path: "/casino/ab20", title: "ANDAR BAHAR 20" },
    { path: "/casino/abj", title: "ANDAR BAHAR 2" },
    { path: "/casino/lucky7", title: "LUCKY 7 - A" },
    { path: "/casino/lucky7eu", title: "LUCKY 7 - B" },
    { path: "/casino/3cardj", title: "3 CARD JUDGEMENT" },
    { path: "/casino/war", title: "CASINO WAR" },

    { path: "/casino/worli", title: "WORLI MATKA" },
    { path: "/casino/worli2", title: "Instant Worli" },
    { path: "/casino/aaa", title: "AMAR AKBAR ANTHONY" },
    { path: "/casino/btable", title: "Bollywood Casino" },
    // { path: "/casino/aaa", title: "AMAR AKBAR ANTHONY" },
    { path: "/casino/lottcard", title: "LOTTERY CARD" },
    { path: "/casino/cricketv3", title: "CRICKET V3" },
    { path: "/casino/cmatch20", title: "CRICKET MATCH 20" },
    { path: "/casino/cmeter", title: "CRICKET METER" },
    { path: "/casino/teen6", title: "TEENPATTI 2.0" },
    { path: "/casino/queen", title: "QUEEN" },
    { path: "/casino/race20", title: "RACE 20" },
    { path: "/casino/lucky7eu2", title: "LUCKY 7 - C" },
    { path: "/casino/superover", title: "SUPER OVER" },
    { path: "/casino/trap", title: "TRAP" },
    { path: "/casino/patti2", title: "2 CARDS TEENPATTI" },
    { path: "/casino/teensin", title: "29 CARD BACCARAT" },
    { path: "/casino/teenmuf", title: "MUFLIS" },
    { path: "/casino/race17", title: "RACE 17" },
    { path: "/casino/teen20b", title: "20 20 TEENPATTI B" },
    { path: "/casino/trio", title: "TRIO" },
    { path: "/casino/notenum", title: "NOTE NUMBER" },
    { path: "/casino/kbc", title: "KBC" },
    { path: "/casino/teen120", title: "1 CArd 20- 20" },
    // { path: "/casino/kbc", title: "KBC" },   Table UI okk but not logicaly working ,bet is added
    { path: "/casino/teen1", title: "1 Card 1 one-day" },
    { path: "/casino/ab3", title: "ANDAR BAHAR 50 Cards" },
    { path: "/casino/aaa2", title: "AMAR AKBAR ANTHONY 2" },
    { path: "/casino/race2", title: "RACE 20-20" },
    { path: "/casino/teen3", title: "TEENPATTI" },
    { path: "/casino/dum10", title: "DUM 10" },

    // { path: "/casino/dum10", title: "DUM 10" }, () table UI  dum 10 is working now)


    //-------------pending table games-----------------------------------------------------------------------








    { path: "/casino/cmeter1", title: "1 Card Meter" },

    // { path: "/casino/kbc", title: "KBC" },
    // { path: "/casino/lucky5", title: "LUCKY 5" },


    // { path: "/casino/roulette11", title: "ROULETTE 11" },
    // { path: "/casino/roulette12", title: "ROULETTE 12" },
    // { path: "/casino/roulette13", title: "ROULETTE 13" },
];
